import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

export default function SinglePage(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  function firstPage() {
    setPageNumber(1);
  }

  function lastPage() {
    setPageNumber(numPages);
  }

  const { pdf } = props;

  return (
    <div className="w-full center space-y-4">
      {/* style={{ minHeight: "calc(100vh - 80px)" }} */}
      <Document file={pdf} options={{ workerSrc: "/pdf.worker.js" }} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <div className="space-y-4">
        <p>
          Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
        </p>
        <div className="space-x-4">
          <button type="button" className="btn btn-outline-primary" disabled={pageNumber <= 1} onClick={firstPage}>
            {` <<`}
          </button>
          <button type="button" className="btn btn-outline-primary" disabled={pageNumber <= 1} onClick={previousPage}>
            {` <`}
          </button>
          <button type="button" className="btn btn-outline-primary" disabled={pageNumber >= numPages} onClick={nextPage}>
            {`  >`}
          </button>
          <button type="button" className="btn btn-outline-primary" disabled={pageNumber >= numPages} onClick={lastPage}>
            {`  >>`}
          </button>
        </div>
      </div>
    </div>
  );
}
